import api from './api';

const STORAGE_KEY = 'zoe';
const STORAGE_KEY_OVERRIDE = 'zoe-override';

const getOverrideToken = () => localStorage.getItem(STORAGE_KEY_OVERRIDE);

export const auth = {
  getToken: () => getOverrideToken() ?? localStorage.getItem(STORAGE_KEY),
  setToken: (token: string) => localStorage.setItem(STORAGE_KEY, token),
  async logOut() {
    await api.delete(`/sessions/current`);
    localStorage.removeItem(
      getOverrideToken() == null ? STORAGE_KEY : STORAGE_KEY_OVERRIDE
    );
    window.location.assign('/');
  },
  getOverrideToken,
  setOverrideToken: (token: string) =>
    localStorage.setItem(STORAGE_KEY_OVERRIDE, token),
};
